export const iconFontAwesomeTransportationCar = (
	<i className="fa-solid fa-car"></i>
);
